import { Container } from 'react-bootstrap';
import Meta from '../Components/Meta';
import BackButton from "../Components/BackButton";

export default function ReturnPolicyScreen() {
  return (
    <>
      <BackButton />
      <Container className="py-4">
        <Meta
          title="Return & Refund Policy | KCC Parts Distribution"
          description="Return & refund policy for KCC Parts Distribution automotive components in Canada."
          canonicalPath="/returns/policy"
        />

        <h1 className="mb-3">Return & Refund Policy</h1>
        <p>
          <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
        </p>

        <h5 className="mt-4">1. Eligibility for Returns</h5>
        <ul>
          <li>Requests must be made within <strong>30 days</strong> of delivery.</li>
          <li>
            Items must be <strong>new, unused, and uninstalled</strong> in their{' '}
            <strong>original packaging</strong>.
          </li>
          <li>
            Electrical/electronic parts are <strong>non-returnable</strong> once installed.
          </li>
          <li>
            Items that show signs of use, installation, or customer-caused damage will not be
            accepted.
          </li>
        </ul>

        <h5 className="mt-3">2. Return Authorization (RMA)</h5>
        <p>
          All returns require an <strong>RMA (Return Merchandise Authorization)</strong>. Start a
          request from your account or email us at{' '}
          <a href="mailto:info@kccparts.ca">info@kccparts.ca</a> with your Order Number, item(s),
          and reason for return.
        </p>
        <p>Returns sent without an RMA may be rejected or delayed.</p>

        <h5 className="mt-3">3. Shipping Label & Cost</h5>
        <ul>
          <li>We can issue a prepaid return label for your convenience.</li>
          <li>
            <strong>Return label cost is paid by the customer</strong> and is{' '}
            <strong>non-refundable</strong>. It will be deducted from the refund or charged
            separately.
          </li>
          <li>You may also return items using your own carrier at your expense.</li>
          <li>
            If KCC made an error or the item arrived damaged/incorrect,{' '}
            <strong>we cover the label cost</strong>.
          </li>
        </ul>

        <h5 className="mt-3">4. Refunds</h5>
        <ul>
          <li>
            Refunds are processed within <strong>5–10 business days</strong> after the returned item
            is received and inspected.
          </li>
          <li>
            <strong>Product price and applicable taxes are refundable.</strong>
          </li>
          <li>
            <strong>Shipping fees, duties, and return label costs are non-refundable.</strong>
          </li>
          <li>
            A <strong>restocking fee of up to 15%</strong> may apply on non-defective returns.
          </li>
        </ul>

        <h5 className="mt-3">5. Exchanges</h5>
        <p>
          We do not offer direct exchanges. If you need a different item, place a new order and
          request an RMA for the original product.
        </p>

        <h5 className="mt-3">6. Damaged or Incorrect Items</h5>
        <p>
          If your order arrives damaged, defective, or incorrect, report it within{' '}
          <strong>48 hours</strong> of delivery (please include photos). We’ll provide a prepaid
          return label and ship a replacement at no cost to you.
        </p>

        <h5 className="mt-3">7. Non-Returnable Items</h5>
        <ul>
          <li>
            Items that have been installed, used, or altered (unless defective due to our error).
          </li>
          <li>Electrical/electronic components once installed.</li>
          <li>Items returned without an RMA.</li>
        </ul>

        <h5 className="mt-3">8. Contact</h5>
        <p>
          Email: <a href="mailto:info@kccparts.ca">info@kccparts.ca</a>
          <br />
          Phone: <a href="tel:+16134074708">+1 613 407 4708</a>
          <br />
          Address: 114-15 Capella Ct, Ottawa, ON K2E 7X1, Canada
        </p>

        <hr />
        <p className="small text-muted mb-0">
          Summary: Customer-choice returns are refunded minus return label cost (if we issued one),
          shipping, duties, and any applicable restocking fee. Product price and applicable taxes
          are refundable. KCC-error, incorrect, or damaged-in-transit cases are covered by KCC.
        </p>
      </Container>
    </>
  );
}
